export default __webpack_public_path__ + "static/media/Weaves-Of-Maheshwar.485c3d01.jpg";